import React, { Component } from 'react'
import s from './EditDriverForm.css'
import { Field, reduxForm, formValueSelector } from 'redux-form';
import submit from './submit';
import validate from './validate';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
//Style
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import {
    Form,
    Col,
    Row,
    Badge,
    Container,
    Button,
    Collapse,
    Modal
} from 'react-bootstrap'
import Link from '../../Link'
import messages from '../../../locale/messages';
import CountryList from '../../CountryList';
// import Dropzone from './Dropzone';
// import LicenceFrontDropzone from './LicenceFrontDropzone'
// import LicenceBackDropzone from './LicenceBackDropzone'
import { api, licenseuploadDir, vehicleUploadDir } from '../../../config';
import Loader from '../../Common/Loader';
// import RCDropzone from './RCDropzone';
// import InsuranceDropzone from './InsuranceDropzone';
import { FaArrowLeft, FaChevronDown, FaChevronUp } from 'react-icons/fa';
import { FaPowerOff, FaTruckFast } from 'react-icons/fa6';
import { getAvatarUrl, getUiAvatarUrl } from '../../../utils/getAvatarUrl';
import Lightbox from '../../Common/Lightbox/Lightbox';
import OngoingBookings from './OngoingBookings';
import { adminResetDriverStatus } from '../../../actions/siteadmin/adminResetDriverStatus';
import Select from 'react-select';

export class EditDriverForm extends Component {

    constructor(props) {
        super(props)

        this.state = {
            countryCode: 'ID',
            country: '+62',
            lightboxOpen: false,
            lightboxImage: '',
            documentsOpen: false,
            showResetConfirm: false
        }

        this.handleChange = this.handleChange.bind(this);
        this.handleCountryChange = this.handleCountryChange.bind(this);
    }

    static defaultProps = {
        loading: false
    };

    renderSelectField = ({ input, label, type, meta: { touched, error }, labelClass, fieldClass, placeholder, children }) => {
        const { formatMessage } = this.props.intl
        return (
            <Form.Group className='positionRelative'>
                <Form.Label className='inputLabel'>{label}</Form.Label>
                <Form.Control as="select" {...input} placeholder={placeholder} className={fieldClass}>
                    {children}
                </Form.Control>
                {touched && error && <span className={cx(s.errorMessage, 'errorMessageRTL')}>{formatMessage(error)}</span>}
            </Form.Group>
        )
    }


    renderField = ({ input, label, type, meta: { touched, error }, fieldClass, placeholder, disabled }) => {
        const { formatMessage } = this.props.intl
        return (
            <Form.Group className='positionRelative'>
                <Form.Label className='inputLabel'>{label}</Form.Label>
                <Form.Control {...input} placeholder={placeholder} type={type} className={fieldClass} disabled={disabled} />
                {touched && error && <span className={cx(s.errorMessage, 'errorMessageRTL')}>{formatMessage(error)}</span>}
            </Form.Group>
        )
    }

    renderFieldPhoneNumber = ({ input, label, writeOnce, type, meta: { touched, error }, fieldClass, placeholder, disabled }) => {
        const { formatMessage } = this.props.intl
        return (
            <Form.Group className='positionRelative'>
                <Form.Label className='inputLabel'>{label}</Form.Label>
                <Form.Control {...input} readOnly={writeOnce} placeholder={placeholder} type={type} className={fieldClass} disabled={disabled} />
                {touched && error && <span className={cx(s.errorMessage, 'errorMessageRTL')}>{formatMessage(error)}</span>}
            </Form.Group>
        )
    }

    handleChange(event) {
        this.setState({ [event.target.name]: event.target.value });
    }

    handleCountryChange(e, selectedData) {
        this.setState({
            country: selectedData.dialCode,
            countryCode: selectedData.countryCode
        });
    }

    handleOpenLightbox = (imageSrc) => {
        this.setState({
            lightboxOpen: true,
            lightboxImage: imageSrc
        });
    }

    handleCloseLightbox = () => {
        this.setState({
            lightboxOpen: false,
            lightboxImage: ''
        });
    }

    toggleDocuments = () => {
        this.setState(prevState => ({ documentsOpen: !prevState.documentsOpen }));
    }

    handleToggleKeyDown = (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            this.toggleDocuments();
        }
    }

    openResetConfirm = () => {
        this.setState({ showResetConfirm: true });
    }

    closeResetConfirm = () => {
        this.setState({ showResetConfirm: false });
    }

    handleResetConfirm = async () => {
        const { getDriver, adminResetDriverStatus, profileId } = this.props;
        if (getDriver && getDriver.id) {
            await adminResetDriverStatus(getDriver.id, profileId);
        }
        this.closeResetConfirm();
    }

    componentDidMount() {
        const { initialValues, initialize } = this.props;
        if (initialValues?.country && initialValues.phoneCountryCode) {
            this.setState({
                countryCode: initialValues.phoneCountryCode,
                country: initialValues.country
            });
        }
    }

    renderDriverInfo(user) {
        const { picture } = this.props;
        const { formatMessage } = this.props.intl;
        const fullName = `${user?.profile?.firstName} ${user?.profile?.lastName}`;

        return (
            <div className='d-flex align-items-center' style={{ gap: '1rem' }}>
                <img
                    className='img-fluid'
                    src={picture ? getAvatarUrl(picture) : getUiAvatarUrl(fullName)}
                    style={{ width: '100px', height: '100px', objectFit: 'cover' }}
                    alt='avatar' />

                <div>
                    <h1 className={cx(s.titleTextAdmin, 'textAlignRightRTL')}>
                        {`${fullName}`}
                        <span className={s.userStatusBadge}>
                            <Badge pill variant={user.isActive === 1 && user.isBan === 0 ? 'success' : 'danger'}>
                                {user && user.isActive === 1 && user.isBan === 0 ? formatMessage(messages.online) : formatMessage(messages.offline)}
                            </Badge>
                            {' '}
                            {user && user.isActive === 1 && user.isBan === 0 &&
                                <Badge pill variant={user.activeStatus === "active" ? 'success' : 'danger'}>
                                    <FaTruckFast />{' '}
                                    {user.activeStatus === "active" ? formatMessage(messages.eligibleForADelivery) : formatMessage(messages.notEligibleForADelivery)}
                                </Badge>}
                        </span>
                    </h1>

                    <div>{user?.email}</div>
                    <div>{user?.phoneNumber}</div>
                </div>
            </div>
        )
    }

    renderDriverDocumentImage(uploadDir, fileName, label) {
        if (!fileName) return (
            <div className='text-muted'>{label} is Empty</div>
        );


        return (
            <>
                <img
                    className='img-thumbnail'
                    src={api.apiEndpoint + uploadDir + fileName}
                    alt={label}
                    onClick={() => this.handleOpenLightbox(api.apiEndpoint + uploadDir + fileName)}
                    onKeyDown={(e) => { if (e.key === 'Enter') this.handleOpenLightbox(api.apiEndpoint + uploadDir + fileName) }}

                    style={{ cursor: 'pointer' }}
                />
                <span className='text-muted'>{label}</span>
            </>
        )
    }



    handleDeliveryModulesChange = (selected) => {
        const { change } = this.props;
        change('deliveryModuleIds', selected ? selected.map(opt => opt.value) : []);
    }

    render() {
        const { handleSubmit, picture, licenceFront, licenceBack, loading, submitting, getDriver, rcBookImage, insuranceImage, locationList, ongoingBookings, ongoingBookingsLoading, deliveryTypes, deliveryModuleIds } = this.props
        const { formatMessage } = this.props.intl;
        const { countryCode } = this.state;
        const { vehicleTypes } = this.props;

        return (
            <div className={cx(s.space5, s.spaceTop5, 'tabLabelText')}>
                <Container fluid>
                    <Row>
                        <Col xl={10} lg={12} md={12} sm={12} xs={12} className='mb-4 mx-auto px-0'>
                            <Link to={"/siteadmin/drivers"} className={'btn btn-light'}>
                                <FaArrowLeft className='mr-2' />
                                {formatMessage(messages.goBack)}
                            </Link>
                        </Col>
                    </Row>

                    <Row>

                        <Col xl={10} lg={12} md={12} sm={12} xs={12} className='mb-4 mx-auto'>
                            {this.renderDriverInfo(getDriver)}
                        </Col>


                        <Col xl={10} lg={12} md={12} sm={12} xs={12} className='border mx-auto p-4'>
                            <div className='d-flex align-items-center justify-content-between mb-2'>
                                <h5>Ongoing Booking</h5>
                                <Button variant='light' onClick={this.openResetConfirm}>
                                    <FaPowerOff className='mr-2' />
                                    Reset Active Status
                                </Button>
                            </div>
                            <OngoingBookings
                                ongoingBookings={ongoingBookings}
                                loading={ongoingBookingsLoading}
                            />
                        </Col>


                        <Col xl={10} lg={12} md={12} sm={12} xs={12} className='border mx-auto mt-4 p-4'>
                            <Form className={s.fullWidth} onSubmit={handleSubmit(submit)}>
                                <Col lg={12} md={12} sm={12} xs={12} className='mt-4'>
                                    <h5>Edit Driver</h5>
                                    <Row>
                                        <Col lg={6} md={12} sm={12} xs={12}>
                                            <Form.Group className={s.space3}>
                                                <div>
                                                    <Field
                                                        name="firstName"
                                                        type="text"
                                                        placeholder={formatMessage(messages.firstName)}
                                                        component={this.renderField}
                                                        label={formatMessage(messages.firstName)}
                                                        labelClass={s.labelText}
                                                        fieldClass={s.formControlInput}
                                                    />
                                                </div>
                                            </Form.Group>
                                        </Col>
                                        <Col lg={6} md={12} sm={12} xs={12}>
                                            <Form.Group className={s.space3}>
                                                <div>
                                                    <Field
                                                        name="lastName"
                                                        type="text"
                                                        placeholder={formatMessage(messages.lastName)}
                                                        component={this.renderField}
                                                        label={formatMessage(messages.lastName)}
                                                        labelClass={s.labelText}
                                                        fieldClass={s.formControlInput}
                                                    />
                                                </div>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col lg={12} md={12} sm={12} xs={12}>
                                    <Row>
                                        <Col lg={6} md={12} sm={12} xs={12}>
                                            <Form.Group className={s.space3}>
                                                <div>
                                                    <Field
                                                        name="email"
                                                        type="text"
                                                        component={this.renderField}
                                                        placeholder={formatMessage(messages.email)}
                                                        label={formatMessage(messages.email)}
                                                        labelClass={s.labelText}
                                                        fieldClass={s.formControlInput}
                                                        disabled
                                                    />
                                                </div>
                                            </Form.Group>
                                        </Col>
                                        <Col lg={6} md={12} sm={12} xs={12}>
                                            <Form.Group className={s.space3}>
                                                <div>
                                                    <Field
                                                        name="password"
                                                        type="text"
                                                        placeholder={formatMessage(messages.password)}
                                                        component={this.renderField}
                                                        label={formatMessage(messages.password)}
                                                        labelClass={s.labelText}
                                                        fieldClass={s.formControlInput}
                                                    />
                                                </div>
                                            </Form.Group>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col lg={12} md={12} sm={12} xs={12}>
                                            <Col lg={12} md={12} sm={12} xs={12} className={s.noPadding}>
                                                <label for='phoneNumber' className='inputLabel'>{formatMessage(messages.phoneNumber)}</label>
                                            </Col>
                                            <Row>
                                                <Col lg={6} md={12} sm={12} xs={12}>
                                                    <CountryList
                                                        input={
                                                            {
                                                                name: 'phoneDialCode',
                                                                onChange: this.handleChange,
                                                                value: countryCode,
                                                            }
                                                        }
                                                        className={cx(s.formControlSelect, s.formControlInput, s.space1)}
                                                        dialCode={false}
                                                        getSelected={this.handleCountryChange}
                                                        formName={'EditDriverForm'}
                                                        disabled
                                                    />
                                                </Col>
                                                <Col lg={6} md={12} sm={12} xs={12}>
                                                    <div className={cx(s.displayInlineBlock, s.countryCode)}>
                                                        <Form.Group className={s.space3}>
                                                            <div>
                                                                <Field
                                                                    name="phoneDialCode"
                                                                    type="text"
                                                                    placeholder={formatMessage(messages.phoneDialCode)}
                                                                    component={this.renderFieldPhoneNumber}
                                                                    labelClass={s.labelText}
                                                                    fieldClass={cx(s.formControlInput, s.formControlInputCountryCode, 'inputCountryCode')}
                                                                    writeOnce={true}
                                                                    disabled
                                                                />
                                                            </div>
                                                        </Form.Group>
                                                    </div>
                                                    <div className={cx(s.displayInlineBlock, s.countryPhoneNumber)}>
                                                        <Form.Group className={s.space3}>
                                                            <div>
                                                                <Field
                                                                    name="phoneNumber"
                                                                    type="text"
                                                                    placeholder={formatMessage(messages.phoneNumber)}
                                                                    component={this.renderFieldPhoneNumber}
                                                                    labelClass={s.labelText}
                                                                    fieldClass={cx(s.formControlInput, s.formControlInputCountry, 'formControlInputCountryRTL')}
                                                                    disabled
                                                                />
                                                            </div>
                                                        </Form.Group>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col lg={6} md={12} sm={12} xs={12}>
                                            <Form.Group className={s.space3}>
                                                <div>
                                                    <Field
                                                        name="vehicleName"
                                                        type="text"
                                                        placeholder={formatMessage(messages.vehicleName)}
                                                        component={this.renderField}
                                                        label={formatMessage(messages.vehicleName)}
                                                        labelClass={s.labelText}
                                                        fieldClass={s.formControlInput}
                                                    />
                                                </div>
                                            </Form.Group>
                                        </Col>
                                        <Col lg={6} md={12} sm={12} xs={12}>
                                            <Form.Group className={s.space3}>
                                                <Field
                                                    name="vehicleNumber"
                                                    type="text"
                                                    placeholder={formatMessage(messages.vehicleNumber)}
                                                    component={this.renderField}
                                                    label={formatMessage(messages.vehicleNumber)}
                                                    labelClass={s.labelText}
                                                    fieldClass={s.formControlInput}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col lg={4} md={12} sm={12} xs={12}>
                                            <Form.Group className={s.space3}>
                                                <Field
                                                    name="vehicleType"
                                                    placeholder={formatMessage(messages.vehicleType)}
                                                    component={this.renderSelectField}
                                                    label={formatMessage(messages.vehicleType)}
                                                    labelClass={s.labelText}
                                                    fieldClass={s.formControlInput}
                                                >
                                                    {/* <option value={''}>{formatMessage(messages.vehicleType)}</option> */}
                                                    {
                                                        vehicleTypes?.results?.map((item) => {
                                                            return <option value={item.id}>{item.vehicleName}</option>
                                                        })
                                                    }
                                                </Field>
                                            </Form.Group>
                                        </Col>
                                        <Col lg={4} md={12} sm={12} xs={12}>
                                            <Form.Group className={cx(s.space3, 'positionRelative')}>
                                                <label for='userStatus' className='inputLabel'>{formatMessage(messages.userActiveStatus)}</label>
                                                <Field name="userStatus" className={cx(s.formControlSelect, s.formControlInput)} component="select">
                                                    <option value="pending">⏸️ {formatMessage(messages.pending)}</option>
                                                    <option value="active">✅ {formatMessage(messages.approve)}</option>
                                                    <option value="inactive">🚫 {formatMessage(messages.decline)}</option>
                                                </Field>
                                            </Form.Group>
                                        </Col>
                                        <Col lg={4} md={12} sm={12} xs={12}>
                                            <Form.Group className={cx(s.space3)}>
                                                <div className='positionRelative'>
                                                    <label for='isBan' className='inputLabel'>{formatMessage(messages.banStatus)}</label>
                                                    <Field name="isBan" className={cx(s.formControlSelect, s.formControlInput)} component="select">
                                                        <option value="0">✅ {formatMessage(messages.permit)}</option>
                                                        <option value="1">🚫 {formatMessage(messages.ban)}</option>
                                                    </Field>
                                                </div>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col lg={4} md={12} sm={12} xs={12}>
                                            <Form.Group className={cx(s.space3)}>
                                                <div className='positionRelative'>
                                                    <label htmlFor='locationId' className='inputLabel'>Operational Area</label>
                                                    <Field name="locationId" className={cx(s.formControlSelect, s.formControlInput)} component="select">
                                                        <option value="">Select operational area</option>
                                                        {locationList?.map((location) => (
                                                            <option key={location.id} value={location.id}>{location.locationName}</option>
                                                        ))}
                                                    </Field>
                                                </div>
                                            </Form.Group>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col lg={12} md={12} sm={12} xs={12}>
                                            <Form.Group className={s.space3}>
                                                <Form.Label style={{ fontWeight: 500, fontSize: '14px', color: '#212121', marginBottom: '6px', display: 'block' }}>
                                                    Accepted Delivery Modules
                                                </Form.Label>
                                                <Select
                                                    isMulti
                                                    options={(deliveryTypes || []).map(m => ({ value: m.id, label: m.deliveryName }))}
                                                    value={(deliveryTypes || [])
                                                        .filter(m => (deliveryModuleIds || []).includes(m.id))
                                                        .map(m => ({ value: m.id, label: m.deliveryName }))
                                                    }
                                                    onChange={this.handleDeliveryModulesChange}
                                                    placeholder="Select delivery modules..."
                                                    classNamePrefix="react-select"
                                                    menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
                                                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                </Col>


                                <Col lg={12} md={12} sm={12} xs={12} className={cx(s.textAlignRight, s.spaceTop1)}>
                                    <Form.Group className={s.noMargin}>
                                        <div className={s.displayInlineBlock}>
                                            <Loader
                                                type={"button"}
                                                label={formatMessage(messages.update)}
                                                show={loading}
                                                buttonType={'submit'}
                                                className={cx(s.button, s.btnPrimary)}
                                                disabled={submitting || loading}
                                                isSuffix={true}
                                            />
                                        </div>
                                    </Form.Group>
                                </Col>
                            </Form>

                        </Col>
                    </Row>


                    <Row className='mt-4'>
                        <Col xl={10} lg={12} md={12} sm={12} xs={12} className='border mx-auto p-4'>
                            <div
                                className="d-flex justify-content-between align-items-center mb-4"
                                onClick={this.toggleDocuments}
                                onKeyDown={this.handleToggleKeyDown}
                                role="button"
                                tabIndex={0}
                                aria-expanded={this.state.documentsOpen}
                                style={{ cursor: 'pointer' }}
                            >
                                <h4 className="mb-0">Driver Documents</h4>
                                {this.state.documentsOpen ? <FaChevronUp /> : <FaChevronDown />}
                            </div>
                            <Collapse in={this.state.documentsOpen}>
                                <div>
                                    <h5>Driving Licence</h5>
                                    <Row className='mb-4'>
                                        <Col xl={4} lg={6} md={12} sm={12} xs={12}>
                                            {this.renderDriverDocumentImage(licenseuploadDir, licenceFront, 'Licence Front')}
                                        </Col>
                                        <Col xl={4} lg={6} md={12} sm={12} xs={12}>
                                            {this.renderDriverDocumentImage(licenseuploadDir, licenceBack, 'Licence Back')}
                                        </Col>
                                    </Row>
                                    <h5>Vehicle Detail</h5>
                                    <Row className='mb-4'>
                                        <Col lg={4} md={12} sm={12} xs={12}>
                                            {this.renderDriverDocumentImage(vehicleUploadDir, rcBookImage, 'RC Book')}

                                        </Col>
                                        <Col lg={4} md={12} sm={12} xs={12}>
                                            {this.renderDriverDocumentImage(vehicleUploadDir, insuranceImage, 'Insurance')}
                                        </Col>
                                    </Row>
                                </div>
                            </Collapse>
                        </Col>
                    </Row>

                </Container>
                <Lightbox
                    isOpen={this.state.lightboxOpen}
                    onClose={this.handleCloseLightbox}
                    imageSrc={this.state.lightboxImage}
                />

                <Modal show={this.state.showResetConfirm} onHide={this.closeResetConfirm} centered>
                    <Modal.Header closeButton>
                        <Modal.Title>Confirm Reset Status</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <p>Are you sure you want to reset the active status for this driver?</p>
                        <p className="text-muted small">
                            This will:
                            <ul>
                                <li>Clear all bookings delivery requests/onprogess to rejected</li>
                                <li>Set the driver's active status from 'inactive' to 'active'.</li>
                            </ul>
                        </p>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={this.closeResetConfirm}>
                            Cancel
                        </Button>
                        <Button variant="danger" onClick={this.handleResetConfirm}>
                            Reset Status
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div >
        )
    }
}

const EditDriverFormRedux = reduxForm({
    form: 'EditDriverForm', // a unique name for this form
    validate,
    onSubmit: submit,
    enableReinitialize: true
})(EditDriverForm)

const selector = formValueSelector('EditDriverForm')
const mapState = state => ({
    id: selector(state, 'id'),
    picture: selector(state, 'picture'),
    licenceFront: selector(state, 'licenceFront'),
    licenceBack: selector(state, 'licenceBack'),
    rcBookImage: selector(state, 'rcBookImage'),
    insuranceImage: selector(state, 'insuranceImage'),
    deliveryModuleIds: selector(state, 'deliveryModuleIds'),
    loading: state.loader.EditDriver
})

const mapDispatch = {
    adminResetDriverStatus
}

export default injectIntl(withStyles(s)(connect(mapState, mapDispatch)(EditDriverFormRedux)));